import React from 'react';
import { apiSettings } from '../../../config/apiSettings';

const GoogleButton: React.FC = () => {
    const handleGoogleLogin = () => {
        window.location.href = process.env.REACT_APP_API_URL_BASE + apiSettings.auth.googleLogin;
    };

    return (
        <button
            onClick={handleGoogleLogin}
            type="button"
            className="bg-white text-primaryColor py-2 rounded-md w-full hover:bg-primaryColor hover:text-white flex justify-center items-center gap-2 border border-gray-300"
        >
            <img src="assets/images/icons/google.svg" alt="google" className="w-5 h-5 inline-block" />
            Continue With Google
        </button>
    );
};

export default GoogleButton;
